import { CookieSettingsButton } from "@/components/legal/CookieSettingsButton";

export function Footer() {
  return (
    <footer className="mt-auto border-t border-sidebar-border bg-[var(--nav-bg)] py-4">
      <div className="mx-auto flex max-w-7xl flex-col gap-x-6 gap-y-2 px-4 text-xs text-sidebar-foreground/65 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <span>
          <span className="font-serif text-lg leading-none text-sidebar-foreground/90">
            thexis
          </span>
          <span className="mx-2 text-sidebar-foreground/40">·</span>
          Claim intelligence for UK litigation
        </span>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <span className="text-sidebar-foreground/55">
            For professional legal use only. Not legal or financial advice.
          </span>
          <a href="/privacy" className="inline-flex min-h-[44px] items-center transition-colors hover:text-sidebar-foreground/90">
            Privacy
          </a>
          <CookieSettingsButton className="inline-flex min-h-[44px] items-center transition-colors hover:text-sidebar-foreground/90" />
        </div>
      </div>
    </footer>
  );
}
